import { UsefulLink, UsefulLinksWrapper } from 'nca-acquiring-theme';
import * as React from 'react';
export default {
  UsefulLink,
  UsefulLinksWrapper,
  React
};